import { useLocalization } from '@components/Localization'
import { Container, Link, Text } from '@gassan-ui'
import React, { FC } from 'react'

type Props = {
  onClick: () => void
}

const EmptyState: FC<Props> = ({ onClick }) => {
  const { lang } = useLocalization()
  return (
    <Container py="2rem">
      <Text variant="large">
        {lang === 'nl' ? 'Geen vestigingen gevonden' : 'No stores found'}.
      </Text>
      <Link as="button" variant="brown" onClick={onClick} display="block">
        Reset filters
      </Link>
    </Container>
  )
}

export default EmptyState
